import { gql } from '@apollo/client';

export const GET_PICKUP_EXCEPTION_REASONS = gql`
    query GetExceptionDictionaryForPickup {
        getExceptionDictionaryForPickup {
            exceptionReasonCode
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
            actionDescription
            isUploadsImages
        }
    }
`;

export interface PickupExceptionReason {
    exceptionReasonCode: string;
    secondaryTypeZh: string;
    secondaryTypeEn: string;
    secondaryTypeEs: string;
    actionDescription: string;
    isUploadsImages: boolean;
}

export interface GetPickupExceptionReasonsResponse {
    getExceptionDictionaryForPickup: PickupExceptionReason[];
}
